var map = {
	"./actual-certificate.svg": 8293,
	"./compare-icon.svg": 9340,
	"./favorite-icon.svg": 5504,
	"./icon-youtube.svg": 7030,
	"./no-found-search.svg": 4915,
	"./star.svg": 1193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4213;